<template>
  <section>
    <h4 class="pb-2">{{ $t('message.booking.new_booking.subscription_title') }}</h4>
    <div class="d-flex align-items-stretch text-center">
      <div class="col-6 card card-body flex-items mr-1 pointer-item shadow-sm"
           :class="{'panel-service-active': packageType === null}"
           @click="setPackageType(null)">
        <div class="text-primary">
          {{ $t('message.booking.new_booking.basic') }}
        </div>
        <div class="mt-4">{{ $t('message.subscription.just_once') }}</div>
      </div>
      <div class="col-6 card card-body flex-items ml-1 pointer-item shadow-sm"
           :class="{'panel-service-active': packageType}"
           v-if="unlimitedPackageType"
           @click="setPackageType(unlimitedPackageType)">
        <div class="text-primary">
          {{ $t('message.booking.new_booking.package') }}
        </div>
        <div class="mt-4">{{ $t('message.booking.new_booking.multi_dates_booking') }}</div><br>
        <div class="mt-4 text-pink mt-auto">
          {{ $t('message.booking.new_booking.max_discount', { maxDiscount: maxDiscount }) }}
        </div>
      </div>
    </div>

    <!-- Package promotions -->
    <div class="card shadow-sm" v-if="packageType && packageType.category === 'unlimited'">
      <div class="card-body">
        <div class="text-orange">
          <i class="fas fa-tag"></i> {{ $t('message.package.promotions') }}
        </div>
        <div class="mt-2">
          <ul class="list-unstyled mb-0">
            <li v-for="packageTypeDiscount, index in packageType.package_type_discounts">
              - {{ packageTypeDiscount | multiLangName }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    props: {
      packageType: Object
    },
    data () {
      return {
        from: String,
        unlimitedPackageType: null,
        maxDiscount: null
      }
    },
    computed: {
      ...mapGetters({
        globalState: 'globalVal/getState'
      })
    },
    methods: {
      setPackageType (data) {
        const packageType = (data) ? 'unlimited' : null
        this.$emit('selectPackageType', packageType)
      },
      getUnlimitedPackage () {
        for (let key in this.globalState.packageTypes) {
          const packageType = this.globalState.packageTypes[key]
          if (packageType.category === 'unlimited') {
            this.unlimitedPackageType = packageType
            break
          }
        }

        if (this.unlimitedPackageType) {
          for (let key in this.unlimitedPackageType.package_type_discounts) {
            const packageTypeDiscount = this.unlimitedPackageType.package_type_discounts[key]
            this.maxDiscount = packageTypeDiscount.discount
          }
        }
      }
    },
    mounted () {
      this.getUnlimitedPackage()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/booking/newSteps/components/BookingPlan.vue